module.exports = "./img/desktop_logo.d7b58d2.png";